import React from 'react';
import { Options } from '../../../../util/SelfcareErrorReportTypes.ts';

interface InternetIssueOptionsProps {
    onChange: (value: string) => void;
    options: Options;
}

const InternetIssueOptionsComponent: React.FC<InternetIssueOptionsProps> = ({ onChange, options }) => {
    return (
        <div className={'input-container'}>
            <p>Vælg hvad du oplever med dit internet*</p>
            {Object.keys(options).map((key, v) => {
                return (
                    <p key={v} className={'with-checkbox'}>
                        <input
                            type="radio"
                            id={options[key].name}
                            name="options"
                            value={options[key].name}
                            onChange={event => onChange(event.target.value)}
                        />
                        <label
                            className="checkbox-label checkbox-label--montserrat"
                            htmlFor={options[key].name}
                        >
                            {options[key].display_name}
                        </label>
                    </p>
                );
            })}
        </div>
    );
};

export default InternetIssueOptionsComponent;
